//

export default function WebbDividerMedium() {

  return (
  <>
    <div className="py-3"></div>
  </>
  )
}